import { Crown } from "lucide-react";

export default function ExitIntentModal({ onClose, onUpgrade }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <div
        data-testid="exit-intent-modal"
        className="w-full max-w-md rounded-xl border-2 border-[var(--c-border)] bg-[var(--c-surface)] p-8 shadow-[6px_6px_0px_var(--c-shadow)]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-xl border-2 border-[var(--c-border)] bg-[#1E3A8A] shadow-[3px_3px_0px_var(--c-shadow)]">
            <Crown className="h-7 w-7 text-white" />
          </div>
          <h2 className="font-heading text-2xl font-bold text-[var(--c-text)]">
            Don&apos;t Lose Your Progress!
          </h2>
          <p className="mt-3 text-[var(--c-muted)]">
            You&apos;ve already started building your LLC. Unlock the full guide to finish what you started — all 9 steps, cost estimator, and completion certificate.
          </p>

          <div className="my-5 rounded-xl border-2 border-[var(--c-border)] bg-[var(--c-bg)] p-4">
            <p className="font-heading text-3xl font-black text-[var(--c-text)]">$19</p>
            <p className="text-xs text-[var(--c-muted)]">One-time &middot; Lifetime access</p>
          </div>

          <button
            data-testid="exit-intent-upgrade"
            onClick={onUpgrade}
            className="flex w-full items-center justify-center gap-2 rounded-full border-2 border-[var(--c-border)] bg-[#1E3A8A] px-6 py-3.5 font-bold text-white shadow-[4px_4px_0px_var(--c-shadow)] transition-all hover:-translate-y-1 hover:shadow-[6px_6px_0px_var(--c-shadow)]"
          >
            Unlock Full Guide — $19
          </button>

          <button
            onClick={onClose}
            className="mt-4 text-sm font-medium text-[var(--c-muted)] hover:text-[var(--c-text)]"
          >
            I&apos;ll come back later
          </button>
        </div>
      </div>
    </div>
  );
}
